import { render, staticRenderFns } from "./FinxCalendar.vue?vue&type=template&id=38ac618c"
import script from "./FinxCalendar.vue?vue&type=script&lang=ts"
export * from "./FinxCalendar.vue?vue&type=script&lang=ts"
import style0 from "./FinxCalendar.vue?vue&type=style&index=0&id=38ac618c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports